<template lang="pug">
.rent-object-features-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="plus" @click="openModal()") Neue Bewertung anlegen

  .card.margin-top
    .top(v-if="rentObjectRatings.length > 0")
      b-rate(disabled :value="avgRating" :custom-text="`${avgRating} (${rentObjectRatings.length} Bewertungen)`")
    .main
      b-table(
        :data="rentObjectRatings",
        default-sort-direction="desc",
        default-sort="name",
        hoverable
      )
        b-table-column(field="name", label="Name", sortable, v-slot="props")
          | {{ props.row.name }}
        b-table-column(field="ratingDate", label="Gast am", sortable, v-slot="props")
          | {{ formatDate(props.row.ratingDate) }}
        b-table-column(field="cleanliness", label="Sauberkeit", sortable, v-slot="props")
          | {{ props.row.cleanliness }}
        b-table-column(field="features", label="Ausstattung", sortable, v-slot="props")
          | {{ props.row.features }}
        b-table-column(field="location", label="Standort", sortable, v-slot="props")
          | {{ props.row.location }}
        b-table-column(field="message", label="Nachricht", v-slot="props")
          | {{ props.row.message }}
        b-table-column(v-slot="props")
          div
            b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
              b-button(icon-right="pencil", type="is-secondary" @click="openModal(props.row)")
            .spacer.sm.inline
            b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
              b-button(icon-right="close", type="is-danger" @click="deleteRating(props.row.id)")

  b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6(v-if="formData.id") Preis aktualisieren
          h2.title.is-6(v-else) Neuer Preis {{formData.startDate ? `für den ${formatJSDate(formData.startDate)}` : ''}}
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Name",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Name",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-input(v-model="formData.name")
            ValidationProvider(
              name="Gast am",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Gast am",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                v-date-picker(:columns="2", v-model="formData.ratingDate" :input-debounce="100")
                  template(v-slot='{ inputValue, togglePopover }')
                    input.input(:value='inputValue' @click="togglePopover({ inputDebounce: 100, placement: 'auto-start' })")
            ValidationProvider(
              name="Sauberkeit",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Sauberkeit",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-rate(v-model="formData.cleanliness")
            ValidationProvider(
              name="Ausstattung",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Ausstattung",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-rate(v-model="formData.features")
            ValidationProvider(
              name="Standort",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Standort",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-rate(v-model="formData.location")
            ValidationProvider(
              name="Nachricht",
              rules="",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Nachricht",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-input(type="textarea" v-model="formData.message" maxlength="1000")

              .button-wrapper.margin-top.right
                b-button(
                  type="is-light",
                  @click="isModalActive = false"
                ) Abbrechen
                b-button(
                  v-if="formData.id"
                  type="is-primary",
                  @click="handleSubmit(saveRentObjectRating)"
                ) Aktualisieren
                b-button(
                  v-else
                  type="is-primary",
                  @click="handleSubmit(saveRentObjectRating)"
                ) Speichern
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    id: {
      type: [Number, String],
      default: null,
    }
  },
  data() {
    return {
      isModalActive: false,
      formData: {
        name: null,
        ratingDate: new Date(),
        cleanliness: null,
        features: null,
        location: null
      },
      rentObjectRatings: []
    };
  },
  computed: {
    avgRating() {
      let totalRatings = 0;
      let totalValue = 0;
      for (let i = 0; i < this.rentObjectRatings.length; i += 1) {
        totalValue += this.rentObjectRatings[i].cleanliness;
        totalValue += this.rentObjectRatings[i].features;
        totalValue += this.rentObjectRatings[i].location;
        totalRatings += 4;
      }
      const avg = parseFloat((totalValue/totalRatings).toFixed(2));
      return avg
    }
  },
  methods: {
    newRating() {
      this.formData = {
        name: null,
        ratingDate: new Date(),
        cleanliness: null,
        features: null,
        location: null
      };
      this.isModalActive = true;
    },
    openModal(p) {
      this.formData = {...this.formData, ...p};
      this.formData.ratingDate = DateTime.fromISO(this.formData.ratingDate).toJSDate();
      this.isModalActive = true;
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yyyy")
    },
    async saveRentObjectRating() {
      this.formData.ratingDate = DateTime.fromJSDate(this.formData.ratingDate).toISODate();
      await this.$store.dispatch("rentObjectRatings/create", {
        rentObjectId: this.id,
        ...this.formData
      });
      await this.$store.dispatch("rentObjectRatings/findAll", {
        rentObjectId: this.id,
      });

      this.formData = {
        name: null,
        ratingDate: new Date(),
        cleanliness: null,
        features: null,
        location: null,
        message: null
      };
      this.$refs.form.reset();

      this.rentObjectRatings = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectRatings.all)
      );
      this.isModalActive = false;
    },
    async deleteRating(id) {
      await this.$store.dispatch("rentObjectRatings/delete", {
        id
      });
      await this.$store.dispatch("rentObjectRatings/findAll", {
        rentObjectId: this.id,
      });

      this.rentObjectRatings = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectRatings.all)
      );
    }
  },
  async mounted() {
    await this.$store.dispatch("rentObjectRatings/findAll", {
      rentObjectId: this.id,
    });

    this.rentObjectRatings = JSON.parse(
      JSON.stringify(this.$store.state.rentObjectRatings.all)
    );
  },
};
</script>

<style lang="scss" scoped>
</style>